import { FC, memo, useCallback, useState } from "react";
import { Icon, Notification } from "#/atoms";
import { MENU_ICON_COLOR, NATURAL } from "@/theme";
import {
  StyledArrowIcon,
  StyledMenu,
  StyledMenuHead,
  StyledMenuLink,
  StyledNavLink,
  StyledSubMenu,
  StyledSubMenuItem,
  StyledlinkLabel,
} from "./Menu.styled";

import { MenuProps } from "./Menu.interface";

const Menu: FC<MenuProps> = ({ icon, label, notification, onClick, onLogout, path, state = 'closed', subMenu }) => {

  const [open, setOpen] = useState(state !== 'closed');

  const handleMenuClick = useCallback((ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    ev.stopPropagation();
    ev.preventDefault();
    setOpen(!open)
  }, [open]);

  const handleNavLinkClick = useCallback((ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    ev.stopPropagation();

    if (onClick) {
      onClick();
    }
    
    //setOpen(!open);
  }, [open]);
  
  return (
    <StyledMenu>
      <StyledMenuHead onClick={handleMenuClick}>
        {path ? (
          <StyledNavLink to={path} activeclassname="active">
            <Icon fillColor={MENU_ICON_COLOR} type={icon} />
            <StyledlinkLabel>{label}</StyledlinkLabel>
          </StyledNavLink>
        ) : (
          <StyledMenuLink fontColor={NATURAL.C}>
            <Icon fillColor={MENU_ICON_COLOR} type={icon} />
            <StyledlinkLabel>{label}</StyledlinkLabel>
          </StyledMenuLink>
        )}
        {notification && <Notification>{notification}</Notification>}
        {subMenu && open && (
          <StyledArrowIcon><Icon fillColor={NATURAL.C} type="chevronDown" /></StyledArrowIcon>
        )}
        {subMenu && !open && (
          <StyledArrowIcon>
            <Icon fillColor={NATURAL.C} type="chevronUp" />
          </StyledArrowIcon>
        )}
      </StyledMenuHead>
      {subMenu && open && (
        <StyledSubMenu show={open}>
          {subMenu.map((sub) => {
            if (!sub.path) {
              if (sub.onClick) {
                return (<StyledSubMenuItem key={sub.id}>
                  <StyledNavLink to={"/login"} activeclassname="active" onClick={onLogout}>{sub.label}</StyledNavLink>
                    {sub.notification && <Notification>{sub.notification}</Notification>}
                  </StyledSubMenuItem>)
              }
              else {
                return null
              }
            };

            return (
              <StyledSubMenuItem key={sub.id}>
                <StyledNavLink to={sub.path} activeclassname="active" onClick={handleNavLinkClick}>{sub.label}</StyledNavLink>
                {sub.notification && <Notification>{sub.notification}</Notification>}
              </StyledSubMenuItem>
            )
          })}
        </StyledSubMenu>
      )}
    </StyledMenu>
  );
};

export default memo(Menu);